import React, { useState } from 'react';
import wrapStore from '@src/utils/wrap-store';
import ApplyStore from '@src/pages/apply/store';
import Page from '../../components/page';
import { message } from 'antd';
import cx from 'classnames';
import Link from '@src/components/link';
import { Select, Input, Radio, Checkbox } from 'antd';
import request from '@src/utils/request';

const styles = require('./index.less');

const Apply = ({ store }) => {
  store.use();
  const getLocationLabel = item => {
    // 检查 item.locations 是否存在
    if (!item || !item.locations) return null;

    const locationLabels = item.locations
      .map(location => {
        const { city, province } = location;
        const hasCity = Boolean(city);
        const hasProvince = Boolean(province);

        if (!hasCity && !hasProvince) return null;

        return (
          <div className={styles.itemLocation}>
            {hasCity && city}
            {hasCity && hasProvince && ', '}
            {hasProvince && province}
          </div>
        );
      })
      .filter(label => label !== null);

    if (locationLabels.length === 0) return null;

    return locationLabels;
  };
  const [fileInfo, setFileInfo] = useState(null);
  const [attachmentFileInfo, setAttachmentFileInfo] = useState(null);

  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const handleUploadClick = () => {
    // 比如，触发文件上传对话框
    // document.getElementById('fileInput').click();
    const fileInput = document.getElementById('fileInput');
    fileInput.value = ''; // 重置 input 的值
    fileInput.click();
  };
  const handleAttachmentUploadClick = () => {
    if (store.browseFlag) {
      return;
    }
    // 比如，触发文件上传对话框
    // document.getElementById('fileAttachmentInput').click();
    const fileAttachmentInput = document.getElementById('fileAttachmentInput');
    fileAttachmentInput.value = ''; // 重置 input 的值
    fileAttachmentInput.click();
  };
  const formatFileSize = sizeInBytes => {
    const sizeInMB = sizeInBytes / (1024 * 1024);
    return `${sizeInMB.toFixed(2)} MB`; // 保留两位小数
  };

  const formatTimestamp = timestamp => {
    const date = new Date(timestamp);

    // 使用padStart确保月份、日期、小时、分钟和秒始终为两位数
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份是从0开始的
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const handleFileChange = (e, type) => {
    // console.log(e, type);
    const file = e.target.files[0];
    if (file) {
      const MAX_SIZE = 20 * 1024 * 1024; // 20M 的字节数
      if (file.size > MAX_SIZE) {
        // 这里可以根据你的实际需求修改提示方式，比如使用 alert 或者自定义的提示组件
        // alert('文件大小不能超过 20M，请重新选择文件。');
        message.info('文件大小不能超过20M，请重新选择文件。');
        return;
      }

      const formattedSize = formatFileSize(file.size);
      const formattedDate = formatTimestamp(file.lastModified);
      // console.log(formattedSize);
      let imgPath;
      const extension = file.name
        .split('.')
        .pop()
        .toLowerCase();

      switch (extension) {
        case 'pdf':
          imgPath = store.pageConfig.pdf_icon;
          break;
        case 'doc':
          imgPath = store.pageConfig.doc_icon;
          break;
        case 'docx':
          imgPath = store.pageConfig.docx_icon;
          break;
        case 'ppt':
          imgPath = store.pageConfig.ppt_icon;
          break;
        case 'pptx':
          imgPath = store.pageConfig.pptx_icon;
          break;
        case 'wps':
          imgPath = store.pageConfig.wps_icon;
          break;
        case 'jpg':
          imgPath = store.pageConfig.jpg_icon;
          break;
        case 'png':
          imgPath = store.pageConfig.png_icon;
          break;
        case 'txt':
          imgPath = store.pageConfig.txt_icon;
          break;
        default:
          imgPath = store.pageConfig.default_icon;
          break;
      }
      // console.log(type === 'attachment');
      if (type === 'attachment') {
        // console.log({
        //   name: file.name,
        //   size: formattedSize,
        //   lastModified: formattedDate,
        //   img: imgPath
        // });
        setAttachmentFileInfo({
          name: file.name,
          size: formattedSize,
          lastModified: formattedDate,
          img: imgPath
        });
      } else {
        setFileInfo({
          name: file.name,
          size: formattedSize,
          lastModified: formattedDate,
          img: imgPath
        });
      }

      // setFileInfo({
      //   name: file.name,
      //   size: formattedSize,
      //   lastModified: formattedDate,
      //   img: imgPath
      // });
      uploadFile(file, type);
      // setUploading(true);
    }
  };
  const uploadFile = async (file, type) => {
    // console.log(file);
    const formData = new FormData();

    // formData.append('upload_file', file);
    // store.state.resume = formData;
    // store.state.resume.append('upload_file', file);
    if (type === 'resume') {
      store.state.resume = file;
      store.resumeFlag = false;
    } else {
      store.state.attachments = file;
    }

    return;
    request
      .post('api/ssg_recruiting_cn/v1/api-platform/v1/file/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: progressEvent => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          console.log(percentCompleted);

          setUploadProgress(percentCompleted);
        }
      })
      .then(response => {
        setUploading(false);
        console.log(' successful', response.data);
      })
      .catch(error => {
        console.error('Error uploading file', error);
      });
    // .finally(() => {
    //   setUploading(false);
    // });
  };

  //   setUploadProgress(0);
  //   const uploadDuration = 10000;
  //   const incrementInterval = 10;
  //   const increments = uploadDuration / incrementInterval;
  //   const progressIncrement = 100 / increments;

  //   let progress = 0;
  //   const intervalId = setInterval(() => {
  //     progress += progressIncrement;
  //     setUploadProgress(Math.floor(progress));

  //     if (progress >= 100) {
  //       clearInterval(intervalId);

  //       setUploading(false);
  //     }
  //   }, incrementInterval);
  // };

  const deleteFile = type => {
    if (type === 'resume') {
      setFileInfo(null);
      store.state.resume = undefined;
    } else {
      setAttachmentFileInfo(null);
      store.state.attachments = undefined;
    }
  };

  return (
    <Page className={styles.root}>
      {store.isLoading && (
        <div className={styles.loading}>
          <div className={styles.loadingBox}>
            <div className={styles.loadingImg} style={{ backgroundImage: `url("${store.pageConfig.loading_icon}")` }} />
            <div className={styles.loadingTxt}>{store.pageConfig.loading_text}</div>
          </div>
        </div>
      )}

      <div className={styles.kv} style={{ backgroundImage: `url("${store.pageConfig.kv_img}")` }} />
      {/* <div className={styles.kv} style={{ backgroundImage: `url("${store.pageConfig.kv_img}")` }} /> */}

      <div className={styles.sidebar}>
        <div className={styles.line}>
          <div className={styles.iconLine} style={{ top: ` ${0.04688 + 0.20833 * store.sidebarCurrentIndex}rem` }} />
        </div>
        {store.sidebar.map((item, index) => {
          return (
            <Link
              className={cx(styles.item, store.sidebarCurrentIndex === index && styles.active)}
              key={index}
              onClick={() => store.onScrollToElement(item.id, index)}
            >
              {item.text}
            </Link>
          );
        })}
      </div>

      <div className={styles.biographicalNotes}>
        <div className={cx(styles.jobTitle, store.prior === '1' && styles.hotspot)}>
          {store.prior === '1' && <div className={styles.iconHotspot} />}
          {store.jobInfo?.title}
        </div>
        <div className={styles.jobLabelInfo}>
          <div className={styles.itemLabel}>{store.jobInfo.commitment}</div>
          {/* <div className={styles.itemLabel}>{store.jobInfo.department && store.jobInfo.department.name}</div> */}
          <div className={styles.itemLabel}>{store.jobInfo.zhineng && store.jobInfo.zhineng.name}</div>
          {getLocationLabel(store.jobInfo)}
          {/* <div className={styles.itemLabel}>
            {store.jobInfo.locations?.[0]?.city || store.jobInfo.locations?.[0]?.province || store.jobInfo.locations?.[0]?.country}
          </div> */}
        </div>

        <div className={styles.columnBox} id="applicationInformation">
          <div className={styles.columnTitle}>{store.pageConfig.apply_information}</div>
          <div className={styles.inputList}>
            <div className={cx(styles.itemInputBox)}>
              <div className={cx(styles.label)}>
                <span className={cx(styles.labelText, styles.need)}>{store.pageConfig.recommend_code}</span>
                <div className={styles.application_container}>
                  <span className={styles.application_icon} />
                  <div className={styles.application_down_text}>{store.pageConfig.recommend_code_tips}</div>
                </div>
              </div>

              {store.browseFlag ? (
                <div className={styles.inputTextBox}>{store.browseList.basicInfo.referralCode || '-'}</div>
              ) : (
                <Input
                  placeholder={store.pageConfig.please_fill_in}
                  value={store.state.basicInfo.referralCode}
                  onChange={e => store.handleChange('basicInfo', 'referralCode', e.target.value)}
                  className={styles.itemInput}
                  maxLength={'200'}
                />
              )}
            </div>
          </div>
        </div>
        <div className={styles.columnBox} id="uploadFile">
          <div className={styles.columnTitle}>{store.pageConfig.upload_files}</div>
          <div className={styles.inputList}>
            <div className={cx(styles.itemInputBox, store.resumeFlag && styles.required)}>
              <div className={cx(styles.label)}>
                <span className={cx(styles.labelText, styles.need)}>{store.pageConfig.upload_resume}</span>
                {/* <span className={styles.iconRequired} style={{ backgroundImage: `url("${store.pageConfig.icon_required}")` }} /> */}
                <span className={styles.iconRequired} />
                {store.resumeFlag && <span className={styles.errorText}>{store.pageConfig.upload_resume_prompt}</span>}
                {fileInfo ? (
                  <div className={styles.upload}>
                    {!store.browseFlag && (
                      <Link className={styles.btnDelete} onClick={() => deleteFile('resume')}>
                        {store.pageConfig.delete_text}
                      </Link>
                    )}
                    <div className={styles.upload_box}>
                      <div className={styles.file_img} style={{ backgroundImage: `url("${fileInfo.img}")` }} />
                      <div className={styles.file_name}>{fileInfo.name}</div>
                      {!uploading && (
                        <div className={styles.file_size_data}>
                          <span className={styles.file_size}>{fileInfo.size}</span>
                          <span> {fileInfo.lastModified} </span>
                        </div>
                      )}
                      {uploading && (
                        <div className={styles.progress_bar}>
                          <div className={styles.progress} style={{ width: `${uploadProgress}%` }} />
                        </div>
                      )}
                      {uploading && <div className={styles.progress_text}>{uploadProgress}%</div>}
                    </div>
                  </div>
                ) : (
                  <div className={styles.upload}>
                    <div className={cx(styles.upload_btn, store.browseFlag && styles.disable)} onClick={handleUploadClick}>
                      <div className={styles.upload_icon} style={{ backgroundImage: `url("${store.pageConfig.upload_icon}")` }} />
                      {store.pageConfig.job_send}
                    </div>
                    <div className={styles.upload_text}>{store.pageConfig.resume_attachment}</div>
                  </div>
                )}
                <input type="file" id="fileInput" style={{ display: 'none' }} onChange={e => handleFileChange(e, 'resume')} />
              </div>
            </div>

            <div className={cx(styles.itemInputBox)}>
              <div className={cx(styles.label)}>
                <span className={cx(styles.labelText, styles.need)}>{store.pageConfig.upload_attachments}</span>
                {/* <span className={styles.iconRequired} style={{ backgroundImage: `url("${store.pageConfig.icon_required}")` }} /> */}

                {attachmentFileInfo ? (
                  <div className={styles.upload}>
                    {!store.browseFlag && (
                      <Link className={styles.btnDelete} onClick={() => deleteFile('attachment')}>
                        {store.pageConfig.delete_text}
                      </Link>
                    )}

                    <div className={styles.upload_box}>
                      <div className={styles.file_img} style={{ backgroundImage: `url("${attachmentFileInfo.img}")` }} />
                      <div className={styles.file_name}>{attachmentFileInfo.name}</div>

                      {!uploading && (
                        <div className={styles.file_size_data}>
                          <span className={styles.file_size}>{attachmentFileInfo.size}</span>
                          <span> {attachmentFileInfo.lastModified} </span>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className={styles.upload}>
                    <div className={cx(styles.upload_btn, store.browseFlag && styles.disabled)} onClick={handleAttachmentUploadClick}>
                      <div className={styles.upload_icon} style={{ backgroundImage: `url("${store.pageConfig.upload_icon}")` }} />
                      {store.pageConfig.job_attachment}
                    </div>
                    <div className={styles.upload_text_attachment}>{store.pageConfig.upload_other_attachments}</div>
                  </div>
                )}
                <input type="file" id="fileAttachmentInput" style={{ display: 'none' }} onChange={e => handleFileChange(e, 'attachment')} />
              </div>
            </div>

            {/* <div className={cx(styles.itemInputBox)}>
              <div className={cx(styles.label)}>
                <span className={cx(styles.labelText, styles.need)}>其他附件</span>
                <div className={styles.upload}>
                  <div className={styles.upload_btn}>
                    <div className={styles.upload_icon} />
                    上传附件
                  </div>
                  <div className={styles.upload_text}>支持文档、图片、压缩包、视频、音频、设计文件等格式文件，所有附件大小总和不超过50MB</div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
        <div className={styles.columnBox} id="personalInformation">
          <div className={styles.columnTitle}>{store.pageConfig.personal_information}</div>

          <div className={styles.inputList}>
            <div className={cx(styles.itemInputBox, store.nameFlag && styles.required)}>
              <div className={cx(styles.label)}>
                <span className={cx(styles.labelText, styles.need)}>{store.pageConfig.nike_name}</span>
                {/* <span className={styles.iconRequired} style={{ backgroundImage: `url("${store.pageConfig.icon_required}")` }} /> */}
                <span className={styles.iconRequired} />
                {store.nameFlag && <span className={styles.errorText}>{store.pageConfig.nike_name_tips}</span>}
              </div>

              {store.browseFlag ? (
                <div className={styles.inputTextBox}>{store.browseList.basicInfo.name || '-'}</div>
              ) : (
                <Input
                  // placeholder={store.pageConfig.name_placeholder}
                  placeholder={store.pageConfig.please_fill_in}
                  value={store.state.basicInfo.name}
                  onChange={e => store.handleChange('basicInfo', 'name', e.target.value)}
                  className={styles.itemInput}
                  maxLength={'20'}
                />
              )}
            </div>

            <div className={cx(styles.itemInputBox, (store.mobileNumberFlag || store.mobileInputFlag) && styles.required)}>
              <div className={cx(styles.label, styles.need)}>
                <span className={cx(styles.labelText, styles.need)}>{store.pageConfig.phone_number}</span>
                {/* <span className={styles.iconRequired} style={{ backgroundImage: `url("${store.pageConfig.icon_required}")` }} /> */}
                <span className={styles.iconRequired} />
                {(store.mobileNumberFlag || store.mobileInputFlag) && <span className={styles.errorText}>{store.pageConfig.phone_number_tips}</span>}
              </div>

              {store.browseFlag ? (
                <div className={styles.inputTextBox}>{store.browseList.basicInfo.phone || '-'}</div>
              ) : (
                <div className={styles.itemBox}>
                  <Select
                    className={cx(styles.phoneSelect)}
                    // placeholder={store.pageConfig.select_placeholder}
                    placeholder={store.pageConfig.please_fill_in}
                    value={store.state.basicInfo.mobile_number}
                    onChange={value => store.handleChange('basicInfo', 'mobile_number', value)}
                  >
                    {store.phoneArea.map((item, index) => {
                      return (
                        <Select.Option value={item.value} key={index}>
                          {item.label}
                        </Select.Option>
                      );
                    })}
                  </Select>
                  <Input
                    type="number"
                    className={styles.phoneInput}
                    // placeholder={store.pageConfig.name_placeholder}
                    placeholder={store.pageConfig.please_fill_in}
                    value={store.state.basicInfo.phone}
                    onChange={e => {
                      const newValue = e.target.value;
                      store.handleChange('basicInfo', 'phone', newValue.slice(0, 200));
                    }}
                    maxLength={'200'}
                  />
                </div>
              )}
            </div>
            <div className={cx(styles.itemInputBox, store.emailFlag && styles.required)}>
              <div className={cx(styles.label)}>
                <span>{store.pageConfig.email}</span>
                {/* <span className={styles.iconRequired} style={{ backgroundImage: `url("${store.pageConfig.icon_required}")` }} /> */}
                <span className={styles.iconRequired} />
                {store.emailFlag && <span className={styles.errorText}>{store.pageConfig.email_tips}</span>}
              </div>

              {store.browseFlag ? (
                <div className={styles.inputTextBox}>{store.browseList.basicInfo.email || '-'}</div>
              ) : (
                <Input
                  className={styles.itemInput}
                  // placeholder={store.pageConfig.name_placeholder}
                  placeholder={store.pageConfig.please_fill_in}
                  value={store.state.basicInfo.email}
                  onChange={e => store.handleChange('basicInfo', 'email', e.target.value)}
                  maxLength={'200'}
                />
              )}
            </div>

            <div className={styles.itemInputBox}>
              <div className={cx(styles.label)}>
                <span>{store.pageConfig.gender}</span>
                <span className={styles.iconRequired} />
              </div>
              <div className={cx(styles.itemBox, styles.genderBox)}>
                {store.browseFlag ? (
                  <div className={styles.inputTextBox}>{store.browseList.basicInfo.gender || '-'}</div>
                ) : (
                  <Radio.Group onChange={e => store.handleChange('basicInfo', 'gender', e.target.value)} value={store.state.basicInfo.gender}>
                    {store.genderList.map((item, index) => {
                      return (
                        <Radio value={item.value} key={index}>
                          {item.label}
                        </Radio>
                      );
                    })}
                  </Radio.Group>
                )}
              </div>
            </div>

            <div className={cx(styles.itemInputBox, store.qqNumberFlag && styles.required)}>
              <div className={cx(styles.label)}>
                <span>{store.pageConfig.qq_text}</span>
                {/* <span className={styles.iconRequired} style={{ backgroundImage: `url("${store.pageConfig.icon_required}")` }} /> */}
                <span className={styles.iconRequired} />
                {store.qqNumberFlag && <span className={styles.errorText}>{store.pageConfig.qq_text_tips}</span>}
              </div>

              {store.browseFlag ? (
                <div className={styles.inputTextBox}>{store.browseList.basicInfo.qq_number || '-'}</div>
              ) : (
                <Input
                  value={store.state.basicInfo.qq_number}
                  onChange={e => store.handleChange('basicInfo', 'qq_number', e.target.value)}
                  className={styles.itemInput}
                  // placeholder={store.pageConfig.name_placeholder}
                  placeholder={store.pageConfig.please_fill_in}
                  maxLength={'200'}
                />
              )}
            </div>

            <div className={cx(styles.itemInputBox, store.locationFlag && styles.required)}>
              <div className={cx(styles.label)}>
                <span>{store.pageConfig.location}</span>
                {/* <span className={styles.iconRequired} style={{ backgroundImage: `url("${store.pageConfig.icon_required}")` }} /> */}
                <span className={styles.iconRequired} />
                {store.locationFlag && <span className={styles.errorText}>{store.pageConfig.location_tips}</span>}
              </div>

              {store.browseFlag ? (
                <div className={styles.inputTextBox}>{store.browseList.basicInfo.location || '-'}</div>
              ) : (
                <Input
                  value={store.state.basicInfo.location}
                  onChange={e => store.handleChange('basicInfo', 'location', e.target.value)}
                  className={styles.itemInput}
                  // placeholder={store.pageConfig.name_placeholder}
                  placeholder={store.pageConfig.please_fill_in}
                  maxLength={'200'}
                />
              )}
            </div>

            {store.mode === 'social' && (
              <div className={cx(styles.itemInputBox, store.jobSeekingStatusFlag && styles.required)}>
                <div className={cx(styles.label)}>
                  <span>{store.pageConfig.job_status}</span>
                  {/* <span className={styles.iconRequired} style={{ backgroundImage: `url("${store.pageConfig.icon_required}")` }} /> */}
                  <span className={styles.iconRequired} />
                  {store.jobSeekingStatusFlag && <span className={styles.errorText}>{store.pageConfig.job_status_tips}</span>}
                </div>

                {store.browseFlag ? (
                  <div className={styles.inputTextBox}>{store.browseList.basicInfo.jobSeekingStatus || '-'}</div>
                ) : (
                  <div className={styles.itemBox}>
                    <Select
                      className={cx(styles.itemBox)}
                      // placeholder={store.pageConfig.select_placeholder}
                      placeholder={store.pageConfig.please_select}
                      value={store.state.basicInfo.jobSeekingStatus}
                      onChange={value => store.handleChange('basicInfo', 'jobSeekingStatus', value)}
                    >
                      {store.jobSeekingStatusList.map((item, index) => {
                        return (
                          <Select.Option value={item.label} key={index}>
                            {item.label}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className={styles.footer}>
        <Checkbox checked={store.state.flag.agreement} onChange={e => store.handleChange('flag', 'agreement', e.target.checked)} />

        <div className={styles.agreement_concent}>
          {store.pageConfig.privacy_text}
          <Link href={store.pageConfig.privacy_go} target={'_blank'}>
            {store.pageConfig.privacy_agreement}
          </Link>
          {store.pageConfig.privacy_text2}
        </div>

        {store.browseFlag ? (
          <Link className={styles.clear} onClick={store.clearSelections}>
            {store.pageConfig.btn_edit}
          </Link>
        ) : (
          <Link className={styles.btnCancel} onClick={store.goBack}>
            {store.pageConfig.btn_clear}
          </Link>
        )}

        {store.browseFlag ? (
          <Link className={cx(styles.confirm, !store.state.flag.agreement && styles.disable)} onClick={store.SubmitSuccess}>
            {store.pageConfig.btn_submit}
          </Link>
        ) : (
          <Link className={cx(styles.confirm, !store.state.flag.agreement && styles.disable)} onClick={store.handleSubmit}>
            {store.pageConfig.btn_save}
          </Link>
        )}
      </div>
    </Page>
  );
};

export default wrapStore(Apply, ApplyStore);
